import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../utils/auth";
import { isOwner } from "../../utils/roles";
import { listenForForegroundMessages, refreshPushTokenIfEnabled } from "../../notifications/pushNotifications";

export default function NotificationRuntime() {
  const navigate = useNavigate();
  const { authState } = useAuth();

  useEffect(() => {
    if (!authState.token || !isOwner(authState.role)) return undefined;
    refreshPushTokenIfEnabled();

    let unsubscribe = () => {};
    let active = true;
    listenForForegroundMessages((payload) => {
      const title = payload?.notification?.title || payload?.data?.title || "إشعار";
      const body = payload?.notification?.body || payload?.data?.body || "";
      const url = payload?.data?.url;
      window.dispatchEvent(new Event("girabat-notification"));
      toast.info(
        <div>
          <p className="font-bold">{title}</p>
          {body && <p className="text-sm">{body}</p>}
        </div>,
        {
          containerId: "girabat-push",
          onClick: () => {
            if (url) navigate(url);
          },
        }
      );
    }).then((stop) => {
      if (!active) {
        stop?.();
        return;
      }
      unsubscribe = stop || (() => {});
    });

    const onClick = (event) => {
      const url = event.data?.url;
      if (event.data?.type === "notification-click" && url) navigate(url);
    };
    navigator.serviceWorker?.addEventListener("message", onClick);

    return () => {
      active = false;
      unsubscribe();
      navigator.serviceWorker?.removeEventListener("message", onClick);
    };
  }, [authState.token, authState.role, navigate]);

  return <ToastContainer containerId="girabat-push" position="top-center" />;
}
